// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3Ohac","head":"Table_head__bA6uy","col":"Table_col__cY65M"};